/**
 * Centralized API configuration.
 *
 * The base URL is read from the REACT_APP_BASE_URL environment variable.
 *   - Production default is set in .env  (https://api.oppohq.com/api)
 *   - Local development override lives in .env.local (http://localhost:8000/api)
 *
 * .env.local is gitignored and automatically overrides .env in Create React App,
 * so each developer can point to their own backend without touching shared config.
 */
export const API_BASE_URL = process.env.REACT_APP_BASE_URL;
